import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Tooltip, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import styles from './BiMonthlyPeriodModal.module.scss';

const toDate = (value) => {
    const next = value instanceof Date ? value : new Date(value);
    return Number.isNaN(next.getTime()) ? new Date() : next;
};

const getUtcYear = (value) => toDate(value).getUTCFullYear();

const getUtcPeriodValue = (value) => {
    const month = toDate(value).getUTCMonth();
    return month - (month % 2);
};

const BiMonthlyPicker = ({ visible, onClose, date, onDateChange, t, direction = 'rtl' }) => {
    const biMonthlyPeriods = [
        { label: '1-2', value: 0 },
        { label: '3-4', value: 2 },
        { label: '5-6', value: 4 },
        { label: '7-8', value: 6 },
        { label: '9-10', value: 8 },
        { label: '11-12', value: 10 },
    ];


    const translateLabel = (label) => {
        const translationsMap = {
            '1-2': '1-2',
            '3-4': '3-4',
            '5-6': '5-6',
            '7-8': '7-8',
            '9-10': '9-10',
            '11-12': '11-12',
        };
        return translationsMap[label] || label;
    };
    const [selectedYear, setSelectedYear] = useState(() => getUtcYear(date));

    useEffect(() => {
        if (!visible) return;
        setSelectedYear(getUtcYear(date));
    }, [visible, date]);

    const activePeriodValue = getUtcPeriodValue(date);
    const activeYear = getUtcYear(date);
    
    const handlePeriodChange = (period) => {
        const startMonth = period.value;
        const endMonth = period.value + 1;
        const startDate = new Date(Date.UTC(selectedYear, startMonth, 1));
        const endDate = new Date(Date.UTC(selectedYear, endMonth + 1, 0, 23, 59, 59, 999));
        onDateChange(startDate, endDate);
        onClose();
    };

    const handleYearChange = (direction) => {
        setSelectedYear((prevYear) => prevYear + direction);
    };

    if (!visible) return null;

    // Render through a portal to document.body so the modal is not trapped inside the
    // VAT/Advances panel's stacking context (those panels use `isolation: isolate`),
    // which would otherwise paint it behind other ClientDetails content.
    return ReactDOM.createPortal(
        <div className={styles.overlay} onClick={onClose}>
            <div dir={direction} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modal}>
                    <div className={styles.scroll}>
                        <div className={styles.header}>
                            <Tooltip title={t('Close') || 'Close'}>
                                <IconButton onClick={onClose} className={styles.closeIcon}>
                                    <CancelIcon className={styles.closeIcon} />
                                </IconButton>
                            </Tooltip>
                            <div>{t('SelectBiMonthlyDate')}</div>
                            <div />
                        </div>

                        <div className={styles.yearSelector}>
                            <button
                                type="button"
                                className={styles.yearBtn}
                                onClick={() => handleYearChange(-1)}
                            >
                                −
                            </button>
                            <span className={styles.yearText}>{selectedYear}</span>
                            <button
                                type="button"
                                className={styles.yearBtn}
                                onClick={() => handleYearChange(1)}
                            >
                                +
                            </button>
                        </div>

                        <div className={styles.periods}>
                            {biMonthlyPeriods.map((period) => (
                                <button
                                    type="button"
                                    key={period.value}
                                    className={`${styles.periodBtn} ${
                                        selectedYear === activeYear && period.value === activePeriodValue
                                            ? styles.periodBtnSelected
                                            : ''
                                    }`}
                                    onClick={() => handlePeriodChange(period)}
                                >
                                    {translateLabel(period.label)}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default BiMonthlyPicker;
